var map = {
	"./assess.js": "5e16",
	"./career.js": "fe57",
	"./common.js": "cfc6",
	"./course.js": "f8c5",
	"./home.js": "1a2c",
	"./personal.js": "6263",
	"./query.js": "4eb5",
	"./recommend.js": "bfc6",
	"./tool.js": "7fb9",
	"./web.js": "668d",
	"./wish.js": "dbd6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a08a";